import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAccount } from '../contexts/AccountContext';
import partnerService from '../services/partnerService';

const PartnerStripeGuard = ({ children }) => {
  const { isPartner, isSuperAdmin, solePartnerId } = useAuth();
  const { selectedPartner } = useAccount();
  const [checking, setChecking] = useState(true);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    if (!isPartner || isSuperAdmin) {
      setChecking(false);
      return;
    }

    const partnerId = selectedPartner || solePartnerId;
    if (!partnerId) {
      setChecking(false);
      return;
    }

    partnerService.getStripeConnect(partnerId)
      .then(res => {
        const connected = res.data?.onboardingComplete === true;
        setBlocked(!connected);
      })
      .catch(() => setBlocked(true))
      .finally(() => setChecking(false));
  }, [isPartner, isSuperAdmin, selectedPartner, solePartnerId]);

  if (checking) return <div className="loading">Loading...</div>;

  if (blocked) {
    return (
      <div style={{ maxWidth: 560, margin: '80px auto', textAlign: 'center', padding: '0 24px' }}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ marginBottom: 16 }}>
          <circle cx="24" cy="24" r="22" stroke="#f59e0b" strokeWidth="2"/>
          <path d="M24 14v12M24 34h.01" stroke="#f59e0b" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
        <h2 style={{ marginBottom: 12, fontSize: 20, fontWeight: 600 }}>Stripe Not Connected</h2>
        <p style={{ color: '#6b7280', lineHeight: 1.6 }}>
          Your partner account does not have Stripe set up yet. Please ask your Partner Admin
          to complete Stripe onboarding on the <strong>Partner Settings</strong> screen before
          creating new resources.
        </p>
      </div>
    );
  }

  return children;
};

export default PartnerStripeGuard;
